import _extends from 'babel-runtime/helpers/extends';
import _objectWithoutProperties from 'babel-runtime/helpers/objectWithoutProperties';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _createClass from 'babel-runtime/helpers/createClass';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';

var _class, _temp;

import React, { Component } from 'react';
import classNames from 'classnames';
import propTypes, { defaultProps } from './propTypes';
import Quote from './Quote';

var PullquoteView = (_temp = _class = function (_Component) {
  _inherits(PullquoteView, _Component);

  function PullquoteView() {
    _classCallCheck(this, PullquoteView);

    return _possibleConstructorReturn(this, (PullquoteView.__proto__ || _Object$getPrototypeOf(PullquoteView)).apply(this, arguments));
  }

  _createClass(PullquoteView, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          text = _props.text,
          source = _props.source,
          sourceUrl = _props.sourceUrl,
          float = _props.float,
          className = _props.className,
          props = _objectWithoutProperties(_props, ['text', 'source', 'sourceUrl', 'float', 'className']);

      return React.createElement(
        Quote,
        _extends({}, props, { className: classNames('pullquote-' + float, className) }),
        React.createElement(
          'aside',
          null,
          text
        ),
        !source ? null : React.createElement(
          'figcaption',
          null,
          !sourceUrl ? source : React.createElement(
            'a',
            { href: sourceUrl },
            source
          )
        )
      );
    }
  }]);

  return PullquoteView;
}(Component), _class.propTypes = propTypes, _class.defaultProps = defaultProps, _temp);
export { PullquoteView as default };